<template>
  <a-modal
    :bodyStyle="{'padding-top':'0px'}"
    :width="400"
    title="确定要删除机器人吗？"
    :visible="visible"
    @cancel="handleCancel"
  >
    <a-alert :style="{margin:'20px 0'}" message="删除机器人是一个非常危险的操作，为了您的数据安全，请确认无误后删除！！" banner />
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item label="微信ID" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-decorator="['wx_id', {rules: [{required: true, message: '必填项'}]}]"
            placeholder="请填写机器人微信ID"
          />
        </a-form-item>
        <a-form-item 
          label="确认信息" 
          :labelCol="labelCol" 
          :wrapperCol="wrapperCol"
          :help="'请输入“'+confirm_message+'”'"
        >
          <a-textarea
            v-decorator="['confirm_message', {rules: [{required: true, message: '必填项'}]}]"
            :rows="4"
            :placeholder="confirm_message"
          />
        </a-form-item>
      </a-form>
    </a-spin>
    <template slot="footer">
      <a-button type="danger" @click="handleSubmit" block>确定删除</a-button>
    </template>
  </a-modal>
</template>

<script>
import DeviceApi from '@/api/device'
export default {
  components: {},
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 15 }
      },
      mdl: {},
      currentRobotId: '',
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      confirm_message: '我已知悉此操作会将机器人授权时间、余额以及用户数据全部清除且不可恢复'
    }
  },
  created() {},
  methods: {
    show(currentRobotId) {
      this.currentRobotId = currentRobotId
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          if(values.confirm_message != this.confirm_message){
            this.$message.error("请输入正确的确认信息")
            return false
          }
          this.confirmLoading = true
          DeviceApi.removeDevice({ sub_id: this.currentRobotId, wx_id: values.wx_id })
            .then(res => {
              if (res.code === 1) {
                this.form.resetFields()
                this.$message.success('删除成功')
                this.visible = false
                this.$emit('ok')
              } else {
                this.$message.error(res.msg)
              }
            })
            .finally(() => {
              this.confirmLoading = false
            })
        }
      })
    }
  }
}
</script>
<style lang="less">
</style>
